
<template>
  <div class="p-max-wrap">
    <div class="p-max-1500">
      <swiper ref="mySwiper"
        :options="swiperOption">
        <swiper-slide v-for="item in items"
          :key="item.ID">
          <div class="conent-wrap">
            <div class="info">
              <div class="day ff-tt ft-50">{{ item.NOTETIME | filterDay }}</div>
              <div class="year-month ff-tt ft-20">
                {{ item.NOTETIME | filterMonth }}
              </div>
              <div class="line"></div>
              <div class="text ft-16">{{$t('swipe1')}}</div>
            </div>
            <div class="article">
              <div class="title ft-25">{{ item.PRONAME }}</div>
              <div class="desc ft-14" v-html="item.CONTENT"></div>
              <div class="img-wrap">
                <img :src="item.SMALLPIC | imgFilter" alt="">
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <!-- Optional controls -->
      <div class="optional">
        <div class="pagination-wrap">
          <div class="pagination">
            <div class="swiper-pagination ft-20"></div>
          </div>
        </div>
        <div class="btns-wrap">
          <div class="btns">
            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getHistoryArticleUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  components: {
    swiper,
    swiperSlide
  },

  data () {
    return {
      swiperOption: {
        // Basic 一般选项
        speed: 1600,
        // Loop 环路
        loop: true,
        /* 组件 */
        // Autoplay 自动切换
        autoplay: {
          // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      },
      items: [
        // {
        //   id: 0,
        //   image: '/images/swipe1-1.png',
        //   day: '26',
        //   yearMonth: '2018.08',
        //   title: '0 今日的社会情怀',
        //   desc: '<div>0 2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   id: 1,
        //   image: '/images/swipe1-1.png',
        //   day: '26',
        //   yearMonth: '2018.08',
        //   title: '1 今日的社会情怀',
        //   desc: '<div>1 2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   id: 2,
        //   image: '/images/swipe1-1.png',
        //   day: '26',
        //   yearMonth: '2018.08',
        //   title: '2 今日的社会情怀',
        //   desc: '<div>2 2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   id: 3,
        //   image: '/images/swipe1-1.png',
        //   day: '26',
        //   yearMonth: '2018.08',
        //   title: '3 今日的社会情怀',
        //   desc: '<div>3 2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   id: 4,
        //   image: '/images/swipe1-1.png',
        //   day: '26',
        //   yearMonth: '2018.08',
        //   title: '4 今日的社会情怀',
        //   desc: '<div>4 2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // }
      ]
    }
  },

  mounted () {
    this.fechData()
  },

  methods: {
    fechData () {
      const url = getHistoryArticleUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.items = res.data.proarr
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.conent-wrap {
  padding: 30px;
  .info {
    text-align: center;
    position: absolute;

    .day {
      line-height: 60px;
      color: #8fd6ed;
    }

    .year-month {
      line-height: 30px;
      color: #03192f;
    }

    .line {
      height: 1px;
      background-color: #03192f;
    }

    .text {
      line-height: 30px;
      color: #03192f;
    }
  }
  .article {
    padding-top: 68px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;

    .title {
      text-align: center;
      color: #03192f;
      line-height: 50px;
    }

    .desc {
      padding: 30px;
      color: #3c546e;
      line-height: 40px;
    }
  }
}

.optional {
  position: relative;
  height: 88px;
  margin-bottom: 80px;
  .pagination-wrap {
    position: absolute;
    width: 100%;
    height: 88px;

    .pagination {
      position: relative;
      height: 66px;
    }
  }
  .btns-wrap {
    position: absolute;
    width: 100%;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btns {
      width: 220px;
      position: relative;
      height: 88px;
    }
  }
}

.img-wrap {
  display: flex;
  justify-content: center;
}
@media(max-width: 768px){
  .conent-wrap{
    .info{
      position: static;
    }
    .article{
      padding-top: 0;
      .desc{
        display: none;
      }
    }
  }
}
</style>
